/**
 * combines redux-thunk with promise support
 *
 * @param  {object} store object containing dispatch, getState
 * @param store.dispatch
 * @param store.getState
 * @returns {Promise} resolved promise
 */
export default function thunkPromiseMiddleware({ dispatch, getState }) {
  return next => action => {
    if (typeof action === 'function' && !action.then) {
      return Promise.resolve(action(dispatch, getState));
    }
    return Promise.resolve(next(action));
  };
}
